import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {AppLogo} from 'ui';
import {ROUTES} from 'app/router/routes';
import {UnreadNotificationsBadge, useUnreadNotificationsLabel} from 'features/notifications';
import {NotificationsIcon} from 'shared/icons';
import {AuthorizedLayoutMobileMenu} from './AuthorizedLayoutMobileMenu';

interface AuthorizedLayoutMobileTopBarProps {
	onLogout: () => void;
}

function BurgerGlyphIcon(): React.ReactElement {
	return (
		<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
			<path d="M4 7H20" stroke="currentColor" strokeWidth="1.6" />
			<path d="M4 12H20" stroke="currentColor" strokeWidth="1.6" />
			<path d="M4 17H20" stroke="currentColor" strokeWidth="1.6" />
		</svg>
	);
}

export function AuthorizedLayoutMobileTopBar({onLogout}: AuthorizedLayoutMobileTopBarProps): React.ReactElement {
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const notificationsLabel = useUnreadNotificationsLabel();

	useEffect(() => {
		const mediaQuery = window.matchMedia('(min-width: 640px)');
		const closeOnDesktop = () => {
			if (mediaQuery.matches) {
				setIsMenuOpen(false);
			}
		};

		mediaQuery.addEventListener('change', closeOnDesktop);

		return () => {
			mediaQuery.removeEventListener('change', closeOnDesktop);
		};
	}, []);

	return (
		<header className="relative flex h-14 shrink-0 items-center border-b border-black/10 bg-white pl-6 pr-3 sm:hidden">
			<button
				type="button"
				onClick={() => setIsMenuOpen(true)}
				className="relative z-10 inline-flex h-6 w-6 items-center justify-center text-black"
				aria-label="Открыть меню"
				aria-expanded={isMenuOpen}
			>
				<BurgerGlyphIcon />
			</button>
			<div className="pointer-events-none absolute inset-0 flex items-center justify-center">
				<div className="pointer-events-auto h-4">
					<AppLogo
						to={ROUTES.orders}
						className="!block h-4 w-auto [&_svg]:h-4 [&_svg]:w-auto [&_svg]:object-contain"
					/>
				</div>
			</div>
			<div className="relative z-10 ml-auto">
				<Link
					to={ROUTES.notifications}
					className="relative inline-flex h-11 w-11 items-center justify-center rounded-lg text-black hover:bg-black/[0.04]"
					aria-label={notificationsLabel}
				>
					<NotificationsIcon className="h-6 w-6" />
					<UnreadNotificationsBadge />
				</Link>
			</div>
			{isMenuOpen ? <AuthorizedLayoutMobileMenu onClose={() => setIsMenuOpen(false)} onLogout={onLogout} /> : null}
		</header>
	);
}
